import { VariantProps, cva } from 'class-variance-authority'
import { Loader2Icon } from 'lucide-react'

import { cn } from '@/lib/ui/style-helpers'

const badgeVariant = cva(
  'bg-main-background-interactive-secondary-default text-main-foreground-secondary',
  {
    variants: {
      variant: {
        default:
          'text-main-foreground-secondary group-data-[state=active]:bg-main-background-subtle-semantic-accent group-data-[state=active]:text-main-foreground-accent',
        warning:
          'group-data-[state=active]:bg-main-background-subtle-semantic-warning group-data-[state=active]:text-main-foreground-warning',
      },
    },
  },
)

type TabBadgeProps = {
  badge?: number | string
  className?: string
  isLoading?: boolean
} & VariantProps<typeof badgeVariant>

export const TabBadge = ({ badge, className, isLoading, variant = 'default' }: TabBadgeProps) => {
  if ((!isLoading && badge === undefined) || badge === null) {
    return null
  }
  return (
    <span
      className={cn(
        'flex min-h-5 min-w-5 items-center justify-center',
        'space-x-1 rounded p-1',
        badgeVariant({ variant }),
        '!text-label-small',
        className,
      )}
    >
      {isLoading ? <Loader2Icon className='size-4 animate-spin' /> : badge}
    </span>
  )
}
